export const ApplyWrappedStyles = () => {
  const wrappedCssText = `
      .gift-block__launcher {
        padding-left: 16px !important;
        padding-right: 16px !important;
        border-radius: 1rem !important;
      }
      .gift-block__launcher:hover{
        background-color: #000 !important;
        color: #fff !important;
      }
      .gift-block__launcher .label{
        font-size: 14px !important;
        line-height: 20px !important;
      }
  `;

  setTimeout(() => {
    const elems = document.querySelectorAll("wrapped-gift-block");
    elems.forEach(elem => {
      const newStyle = document.createElement("style");
      newStyle.textContent = wrappedCssText;
      elem?.shadowRoot?.appendChild(newStyle);
    });
  }, 1500);
}
